import Layout from './Layout';
import useResponsive from '../../shared/utils/Responsive';
import TrainerLoginForm from './TrainerLoginForm';
import TrainerSmallScreen from './TrainerSmallScreen';
const TrainerUserLogin = () => {
    const isSmallScreen = useResponsive("md")
    return (
        <>
            {
                !isSmallScreen && (
                    <Layout text={"Trainer login to upload courses, share learning materials, and track how students are engaging with your content."}>
                        <TrainerLoginForm />
                    </Layout>
                )
            }
            {
                isSmallScreen && <TrainerSmallScreen tabPage={0} />
            }

        </>

    )
}
export default TrainerUserLogin










